(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "@braindate/util/lib/assert", "./userAssertions", "../schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("@braindate/util/lib/assert"), require("./userAssertions"), require("../schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.assert, global.userAssertions, global.schema);
    global.userNormalization = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _assert, _userAssertions, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hydrateUser = hydrateUser;
  _exports.hydrateUsers = hydrateUsers;
  _exports.normalizeUser = normalizeUser;
  _exports.normalizeUsers = normalizeUsers;

  /**
   * Normalize a user
   * @param   {User} user - User to normalize
   * @returns {number} data.result - Id of the user
   * @returns {NormalizedData<number> } data.entities - Normalized data entities
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function normalizeUser(user) {
    (0, _userAssertions.assertUser)(user);
    return (0, _normalizr.normalize)(user, _schema.userSchema);
  }

  /**
   * Normalize users
   * @param   {Array<User>} users - Users to normalize
   * @returns {Array<number>} data.result - Ids of the users
   * @returns { NormalizedData<Array<number>>} data.entities - Normalized data
   * entities
   *
   * @throws Will throw an exception if parameter is not an array
   */
  function normalizeUsers(users) {
    (0, _assert.assertArray)(users, "users");
    return (0, _normalizr.normalize)(users, _schema.usersSchema);
  }

  /**
   * Denormalize a user
   * @param   {number} id - Id of the user
   * @param   {Entities} entities - Normalized data entities
   * @returns {User} Denormalized user
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateUser(id, entities) {
    (0, _assert.assertNumber)(id, "id");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(id, _schema.userSchema, entities);
  }

  /**
   * Denormalize users
   * @param   {Array<number>} ids - Ids of the users
   * @param   {Entities} entities - Normalized data entities
   * @returns {Array<User>} Denormalized users
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateUsers(ids, entities) {
    (0, _assert.assertArray)(ids, "ids");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(ids, _schema.usersSchema, entities);
  }
});